import * as React from 'react'
import { Button, CircularProgress } from '@mui/material'
// import { useSnackbarComponent } from "../SnackbarComponents/useSnackbarComponent";
// import { AnalyticService } from "../../lib/analytics/analyticService";
import { useRouter } from 'next/router'
// import SelectUserDialog from "../Auhentication/LoginComponent/SelectUserDialog";

const SignInToSchoolFirebaseButton = (props: {
  text?: string
  schoolDetails: any
  onLoginSuccessful: (data: any) => void
  snackbarHook: any
  userType: string
  isDialog: boolean
}) => {
  const [loginLoading, setLoginLoading] = React.useState(false)
  const snackbarHook = props.snackbarHook
  // const [openSelectUserDialog, setOpenSelectUserDialog] = React.useState(false);
  const router = useRouter()

  const openPledreAuthPage = () => {
    try {
      const pledreAuthPage = new URL(
        window.location.hostname === 'test.demi.com' // local
          ? 'http://auth.demi.com'
          : window.location.hostname.includes('lms-test.pledre.com') // staging
          ? 'https://auth.lms-test.pledre.com'
          : 'https://auth.pledre.com', // production
      )

      const redirectUrl = new URL(window.location.href)
      const continueUrl = new URL(redirectUrl.origin)
      continueUrl.pathname = 'login'
      continueUrl.search = `redirect=${redirectUrl}`

      pledreAuthPage.searchParams.set(
        'continue',
        props.isDialog ? continueUrl.href : redirectUrl.href,
      )
      pledreAuthPage.searchParams.set('user_type', props.userType)
      pledreAuthPage.searchParams.set('login_with', 'google')
      pledreAuthPage.searchParams.set('school_auth_id', props.schoolDetails._id)
      return router.push(pledreAuthPage)
    } catch (error) {
      console.log('An error occured', error)
      snackbarHook.open(
        'An error occurred. Please try again or Login using Password',
        'error',
      )
    }
  }

  return (
    <React.Fragment>
      <Button
        variant={'outlined'}
        color={'primary'}
        style={{ color: '#4e4c6b' }}
        disabled={loginLoading}
        fullWidth={true}
        size={'large'}
        onClick={() => {
          setLoginLoading(true)
          openPledreAuthPage()
          // setOpenSelectUserDialog(true);
        }}
      >
        <div style={{ position: 'absolute', left: '0px', top: '0px' }}>
          <img
            height={'24px'}
            style={{ margin: '8px' }}
            src={
              'https://static.hsappstatic.net/LoginUI/static-1.6708/img/google-logo.png'
            }
          />
        </div>
        {props.text || 'Sign in with google'}
        {loginLoading && <CircularProgress size={20} />}
      </Button>

      {/* <SelectUserDialog */}
      {/*  onSelectUser={openPledreAuthPage} */}
      {/*  openDialog={openSelectUserDialog} */}
      {/*  setOpenDialog={setOpenSelectUserDialog} */}
      {/*  setLoading={setLoginLoading} */}
      {/*  title={"Login as:"} */}
      {/* /> */}
    </React.Fragment>
  )
}

export default SignInToSchoolFirebaseButton
